module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_81-55c0e87533dfcf51b6cf31f28eb36304.png";